import { useSubscriptions } from '../stores/FetcherStores/SubscriptionFetcher';
import { timestampToDate } from '../utils/date';
import useCompanyId from './useCompanyId';

const useIsSubscriptionActive = (subscriptionId: string) => {
  const companyId = useCompanyId();
  const { data: subscriptions } = useSubscriptions(companyId);

  return (
    subscriptions?.some((s) => {
      const endDate = timestampToDate(s.data.endDate);
      return s.id === subscriptionId && (!endDate || endDate > new Date());
    }) || false
  );
};

export default useIsSubscriptionActive;
